import { render, staticRenderFns } from "./employer.vue?vue&type=template&id=59193fbc"
import script from "./employer.vue?vue&type=script&lang=js"
export * from "./employer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports